<script>
    import { onMount } from 'svelte';
    import { globalSizes, filterCategories, personalLinks } from './store';
    import LoaderSkeleton from './shared/LoaderSkeleton.svelte';
    import { logo } from './Svg';

    let windowW;
    let scrollY;

    let heroHTML = 'loading';
    
    onMount(async () => {
        try{
            const response = await fetch('https://andrereitz.com.br/wp-json/reitz/studies/content');

            if(response.ok) {
                const data = await response.json();
                heroHTML = data.hero_content_raw;
                filterCategories.set(data.filters);
                personalLinks.set(data.links);
            } else {
                throw new Error(response.status + " Failed Fetch");
            }
        } catch(err) {
            heroHTML = 'error'
        }
    })
</script>

<svelte:window bind:innerWidth={windowW} bind:scrollY={scrollY} />

<div class="row hero" bind:clientHeight={$globalSizes.heroH}>
    <div class="container">
        <header>
            <span class="logo" style="opacity: {1 - Math.max(0, scrollY / 100)}; transform: translate(0,{scrollY * .4}px)">
                {@html logo}
            </span>
        </header>
        <div class="content">
            {#if heroHTML === 'loading'}
            <LoaderSkeleton gradientColor="#0F90C0" background="rgba(255,255,255,.1)" display="block" maxWidth="300px" margin="14px 0" height="28px" mobileMaxWidth="75%" />
            <LoaderSkeleton gradientColor="#0F90C0" background="rgba(255,255,255,.1)" display="block" maxWidth="500px" margin="8px 0" height="22px" mobileMaxWidth="100%" />
            <LoaderSkeleton gradientColor="#0F90C0" background="rgba(255,255,255,.1)" display="block" maxWidth="250px" margin="8px 0" height="22px" mobileMaxWidth="100%" />

            <LoaderSkeleton gradientColor="#0F90C0" background="rgba(255,255,255,.1)" display="block" maxWidth="300px" margin="14px 0" height="28px" mobileMaxWidth="75%" />
            <LoaderSkeleton gradientColor="#0F90C0" background="rgba(255,255,255,.1)" display="block" maxWidth="250px" margin="8px 0" height="22px" mobileMaxWidth="100%" />
            <LoaderSkeleton gradientColor="#0F90C0" background="rgba(255,255,255,.1)" display="block" maxWidth="500px" margin="8px 0" height="22px" mobileMaxWidth="100%" />
            <LoaderSkeleton gradientColor="#0F90C0" background="rgba(255,255,255,.1)" display="block" maxWidth="500px" margin="8px 0" height="22px" mobileMaxWidth="100%" />
            <LoaderSkeleton gradientColor="#0F90C0" background="rgba(255,255,255,.1)" display="block" maxWidth="250px" margin="8px 0" height="22px" mobileMaxWidth="100%" />
            {:else if heroHTML === 'error' }
                Error loading data
            {:else}
                {@html heroHTML}
            {/if}
            {#if windowW > 1024}
                <i 
                    class="watermark fab fa-github" 
                    style="opacity: {1 - Math.max(0, scrollY / ($globalSizes.heroH - 100))}; transform: translate(0,{scrollY * .2}px) rotate({-25 - (scrollY / 50)}deg)"
                ></i>
            {/if}
        </div>
    </div>
</div>

<style lang="less">
    .hero {
        width: 100%;
        // background: linear-gradient(135deg, #9D34CE 0.42%, #A65FD6 0.43%, #0F90C0 100%);
        background: linear-gradient(135deg, #9D34CE 0%, #0F90C0 100%);
        color: var(--color-white);
        padding: 40px 0;
        overflow: hidden;

        header { 
            width: 100%;
            padding: 0 0 40px 0;
            text-align: center;
            border-bottom: 1px solid var(--color-white);
            margin: 0 0 40px 0;

            .logo {
                width: 280px;
                display: inline-block;
            }
        }
        :global(.content > h1){
            font-size: 24px;
            line-height: 28px;
        }
        :global(.content > h2) {
            font-size: 24px;
            line-height: 28px;
            margin: 25px 0 15px 0;
        }
        :global(.content > p) {
            font-size: 18px;
            line-height: 22px;
            margin: 10px 0;
        }
        :global(a) {
            text-decoration: underline;
            color: var(--color-white);
            font-weight: 600;
        }
        .content {
            position: relative;
            padding: 0 500px 0 0;

            @media screen and (max-width: 1024px) {
                padding: 0 25px;
            }
            .watermark {
                position: absolute;
                bottom: -145px;
                right: 0;
                font-size: 500px;
                color: rgba(255, 255, 255, .2);
            }
        }
    }
</style>